import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Button, Grid, DialogContent, Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import _ from "lodash";
import {verifyAgentConfig, uploadAgentConfig} from "../../../actions/Users/authenticateHub";
import { backupConfigNow, applyGoldenConfig, backupConfigData, getLicenseTypes, upgradeDevicetoLatestEOSversion, rebootDevice, upgradeInventoryLicense } from "../../../actions/Users/authenticateInventory";
import { NEW_PER_PAGE_ITEMS } from "../../../constants/Constants";
import { Pagination } from "../../../components/Pagination";
import { DEFAULT_PAGE_SIZE } from "../../../constants/Constants";
import { toast } from 'react-toastify';
import { VERIFY_AGENT_CONFIG, AGENT_CONFIG_SUMMARY } from "../../../actions/types";

const DEFAULT_PAGE = 1;

export const AgentConfigSummary = (props) => {
    const { authReducer, isEditActionPopup, agentId, agentName, handleClose, selectedDp, uploadedFile, uploadAgentConfig, setIsActionPopup } = props;
    const [accessNetworks, setAccessNetworks] = useState<any>([]);
    const [hubGroups, setHubGroups] = useState<any>([]);
    const [hubs, setHubs] = useState<any>([])
    const [vlans, setVlans] = useState<any>([])
    const [routes, setRoutes] = useState<any>([])
    const [services, setServices] = useState<any>([])
    const [wanInterfaces, setWanInterfaces] = useState<any>([])
    const [hubSelection, setHubSelection] = useState<any>([])
    const [hubWanSelection, setHubWanSelection] = useState<any>([])
    const [summary, setSummary] = useState<any>(null)

    const [accessNetworksPage, setAccessNetworksPage] = useState<number>(DEFAULT_PAGE);
    const [accessNetworksLimit, setAccessNetworksLimit] = useState<number>(DEFAULT_PAGE_SIZE);

    const [hubGroupsPage, setHubGroupsPage] = useState<number>(DEFAULT_PAGE);
    const [hubGroupsLimit, setHubGroupsLimit] = useState<number>(DEFAULT_PAGE_SIZE);

    const [hubLimit, setHubLimit] = useState<number>(DEFAULT_PAGE_SIZE);
    const [hubPage, setHubPage] = useState<number>(DEFAULT_PAGE);

    const [vlanLimit, setVlanLimit] = useState<number>(DEFAULT_PAGE_SIZE);
    const [vlanPage, setVlanPage] = useState<number>(DEFAULT_PAGE);

    const [routeLimit, setRouteLimit] = useState<number>(DEFAULT_PAGE_SIZE);
    const [routePage, setRoutePage] = useState<number>(DEFAULT_PAGE);

    const [servicesPage, setServicesPage] = useState<number>(DEFAULT_PAGE);
    const [servicesLimit, setServicesLimit] = useState<number>(DEFAULT_PAGE_SIZE);

    const [wanInterfacesPage, setWanInterfacesPage] = useState<number>(DEFAULT_PAGE);
    const [wanInterfacesLimit, setWanInterfacesLimit] = useState<number>(DEFAULT_PAGE_SIZE);

    const [hubSelectionPage, setHubSelectionPage] = useState<number>(DEFAULT_PAGE);
    const [hubSelectionLimit, setHubSelectionLimit] = useState<number>(DEFAULT_PAGE_SIZE);

    const [hubWanSelectionPage, setHubWanSelectionPage] = useState<number>(DEFAULT_PAGE);
    const [hubWanSelectionLimit, setHubWanSelectionLimit] = useState<number>(DEFAULT_PAGE_SIZE);

    const dispatch = useDispatch();

    const handleSave = () => {
        if(uploadedFile){
            const payload = new FormData();
            payload.append('agent_id', agentId);
            payload.append('agent_name', agentName ? agentName : agentId);
            payload.append('create_new', isEditActionPopup ? 'false' : 'true');
            payload.append('apply_now', 'false');
            if(uploadedFile) {
                payload.append('file', uploadedFile);
            }
            uploadAgentConfig(selectedDp?.id, payload)
            handleClose();
        }
    }
    const handleApplyNow = () => {
        if(uploadedFile){
            const payload = new FormData();
            payload.append('agent_id', agentId);
            payload.append('agent_name', agentName ? agentName : agentId);
            payload.append('create_new', isEditActionPopup ? 'false' : 'true');
            payload.append('apply_now', 'true');
            if(uploadedFile) {
                payload.append('file', uploadedFile);
            }
            uploadAgentConfig(selectedDp?.id, payload)
            handleClose();
        }
    }

    useEffect(() => {
        if (!_.isEmpty(authReducer?.verifyAgentConfig) && !authReducer?.verifyAgentConfigLoading) {
            let configSummary = authReducer?.verifyAgentConfig
            setAccessNetworks(configSummary?.accessNetworks)
            setHubGroups(
                configSummary?.hubGroups?.flatMap(group =>
                group.hubs.map(hub => ({
                groupName: group.name,
                hubName: hub.name,
                priority: hub.priority,
                }))
                ) || []
            )
            setHubs(
                Array.isArray(configSummary?.hubs)
                    ? configSummary.hubs.flatMap(hub =>
                        Array.isArray(hub.addresses)
                            ? hub.addresses.map(address => ({
                                name: hub.name,
                                balancer : hub.balancer,
                                address: address.address,
                                wanType: address.wanType,
                            }))
                            : []
                    )
                    : []
            );
            setRoutes(configSummary?.routes)
            setVlans(configSummary?.balancers?.flatMap(balancer =>
                balancer.clientConfig?.levels?.flatMap(level => {
                const balancerType = level.balancerType;
                const levelNum = level.level;
                const commonData = {
                    balancerName: balancer.name,
                    serverFollowsClient: balancer.serverFollowsClient,
                    level: levelNum,
                    balancerType
                };
                if (balancerType === 'static') {
                    const weightMap = level.staticBalancer || {};
                    return Object.entries(weightMap).map(([wanName, weight]) => ({
                    ...commonData,
                    wanName,
                    weight
                    }));
                }
                if (balancerType === "dynamic") {
                    const wanNames = level?.wanNames || [];
                    return wanNames?.map(wanName => ({
                        ...commonData,
                        wanName,
                        weight: "-"
                    }));
                }

                return [];
                }) || []
            ) || [])
            setServices(configSummary?.services)
            setWanInterfaces(configSummary?.wanInterfaces)
            setSummary(configSummary?.agent_name)

            if (configSummary?.hubSelection) {
                const hubSelectionConfig = configSummary.hubSelection;
                setHubSelection([{
                    probeServer: hubSelectionConfig?.probeServer || '-',
                    interval: hubSelectionConfig?.interval || '-',
                    selectionMethod: hubSelectionConfig?.wanSelection?.selectionMethod || '-',
                    priorityList: hubSelectionConfig?.wanSelection?.priorityList || [],
                    windowSize: hubSelectionConfig?.exponentialMovingAverage?.windowSize || '-',
                    smoothingFactor: hubSelectionConfig?.exponentialMovingAverage?.smoothingFactor || '-'
                }]);
            }

            if (configSummary?.hubSelection?.wans) {
                const wanSelectionConfig = configSummary.hubSelection.wans;

                const flattened = Object.entries(wanSelectionConfig).flatMap(([wanType, phases]) => {
                    const typedPhases = phases as Record<string, any>; // 👈 Fix type error here

                    return ['initial', 'reselection'].map((phase) => ({
                        wanType,
                        phase,
                        rttDiffThreshold: typedPhases?.[phase]?.rttDiffThreshold || '-',
                        probes: typedPhases?.[phase]?.probes || '-',
                        timeout: typedPhases?.[phase]?.timeout || '-',
                        interval: typedPhases?.[phase]?.interval || '-',
                        timeDelta: typedPhases?.[phase]?.timeDelta || '-'
                    }));
                });

                setHubWanSelection(flattened);
            }

            dispatch({type: VERIFY_AGENT_CONFIG, payload: {}})
        }
    }, [authReducer?.verifyAgentConfig])

    useEffect(() => {
        if (!_.isEmpty(authReducer?.agentConfigSummary) && !authReducer?.agentConfigSummaryLoading && isEditActionPopup) {
            let configSummary = authReducer?.agentConfigSummary
            setAccessNetworks(configSummary?.accessNetworks)
            setHubGroups(
                configSummary?.hubGroups?.flatMap(group =>
                group.hubs.map(hub => ({
                groupName: group.name,
                hubName: hub.name,
                priority: hub.priority,
                }))
                ) || []
            )
            setHubs(
                Array.isArray(configSummary?.hubs)
                    ? configSummary.hubs.flatMap(hub =>
                        Array.isArray(hub.addresses)
                            ? hub.addresses.map(address => ({
                                name: hub.name,
                                balancer : hub.balancer,
                                address: address.address,
                                wanType: address.wanType,
                            }))
                            : []
                    )
                    : []
            );
            setRoutes(configSummary?.routes)
            setVlans(configSummary?.balancers?.flatMap(balancer =>
                balancer.clientConfig?.levels?.flatMap(level => {
                const balancerType = level.balancerType;
                const levelNum = level.level;
                const commonData = {
                    balancerName: balancer.name,
                    serverFollowsClient: balancer.serverFollowsClient,
                    level: levelNum,
                    balancerType
                };
                if (balancerType === 'static') {
                    const weightMap = level.staticBalancer || {};
                    return Object.entries(weightMap).map(([wanName, weight]) => ({
                    ...commonData,
                    wanName,
                    weight
                    }));
                }
                if (balancerType === "dynamic") {
                    const wanNames = level?.wanNames || [];
                    return wanNames?.map(wanName => ({
                        ...commonData,
                        wanName,
                        weight: "-"
                    }));
                }

                return [];
                }) || []
            ) || [])
            setServices(configSummary?.services)
            setWanInterfaces(configSummary?.wanInterfaces)
            setSummary(configSummary?.agent_name)

            if (configSummary?.hubSelection) {
                const hubSelectionConfig = configSummary.hubSelection;
                setHubSelection([{
                    probeServer: hubSelectionConfig?.probeServer || '-',
                    interval: hubSelectionConfig?.interval || '-',
                    selectionMethod: hubSelectionConfig?.wanSelection?.selectionMethod || '-',
                    priorityList: hubSelectionConfig?.wanSelection?.priorityList || [],
                    windowSize: hubSelectionConfig?.exponentialMovingAverage?.windowSize || '-',
                    smoothingFactor: hubSelectionConfig?.exponentialMovingAverage?.smoothingFactor || '-'
                }]);
            }

            if (configSummary?.hubSelection?.wans) {
                const wanSelectionConfig = configSummary.hubSelection.wans;

                const flattened = Object.entries(wanSelectionConfig).flatMap(([wanType, phases]) => {
                    const typedPhases = phases as Record<string, any>; // 👈 Fix type error here

                    return ['initial', 'reselection'].map((phase) => ({
                        wanType,
                        phase,
                        rttDiffThreshold: typedPhases?.[phase]?.rttDiffThreshold || '-',
                        probes: typedPhases?.[phase]?.probes || '-',
                        timeout: typedPhases?.[phase]?.timeout || '-',
                        interval: typedPhases?.[phase]?.interval || '-',
                        timeDelta: typedPhases?.[phase]?.timeDelta || '-'
                    }));
                });

                setHubWanSelection(flattened);
            }
            // dispatch({ type: AGENT_CONFIG_SUMMARY, payload: {}})
        }
    }, [authReducer?.agentConfigSummary])

    const paginatedAccessNetworks = useMemo(() => {
        let pageNumber = accessNetworksPage || 1
        let pageLimit = accessNetworksLimit || DEFAULT_PAGE_SIZE
        const startIndex = (pageNumber - 1) * pageLimit;
        return accessNetworks?.slice(startIndex, startIndex + pageLimit);
    }, [accessNetworks, accessNetworksPage, accessNetworksLimit]);

    const paginatedHubGroups = useMemo(() => {
        let pageNumber = hubGroupsPage || 1
        let pageLimit = hubGroupsLimit || DEFAULT_PAGE_SIZE
        const startIndex = (pageNumber - 1) * pageLimit;
        return hubGroups?.slice(startIndex, startIndex + pageLimit);
    }, [hubGroups, hubGroupsPage, hubGroupsLimit])
    
    const paginatedHubs = useMemo(() => {
        let pageNumber = hubPage || 1
        let pageLimit = hubLimit || DEFAULT_PAGE_SIZE
        const startIndex = (pageNumber - 1) * pageLimit;
        return hubs?.slice(startIndex, startIndex + pageLimit);
    }, [hubs, hubPage, hubLimit]);

    const paginatedVlans = useMemo(() => {
        let pageNumber = vlanPage || 1
        let pageLimit = vlanLimit || DEFAULT_PAGE_SIZE
        const startIndex = (pageNumber - 1) * pageLimit;
        return vlans?.slice(startIndex, startIndex + pageLimit);
    }, [vlans, vlanPage, vlanLimit]);

    const paginatedRoutes = useMemo(() => {
        let pageNumber = routePage || 1
        let pageLimit = routeLimit || DEFAULT_PAGE_SIZE
        const startIndex = (pageNumber - 1) * pageLimit;
        return routes?.slice(startIndex, startIndex + pageLimit);
    }, [routes, routePage, routeLimit]);

    const pagionatedServices = useMemo(() => {
        let pageNumber = servicesPage || 1
        let pageLimit = servicesLimit || DEFAULT_PAGE_SIZE
        const startIndex = (pageNumber - 1) * pageLimit;
        return services?.slice(startIndex, startIndex + pageLimit);
    }, [services, servicesLimit, servicesPage]);

    const paginatedWanInterfaces = useMemo(() => {
        let pageNumber = wanInterfacesPage || 1
        let pageLimit = wanInterfacesLimit || DEFAULT_PAGE_SIZE
        const startIndex = (pageNumber - 1) * pageLimit;
        return wanInterfaces?.slice(startIndex, startIndex + pageLimit);
    }, [wanInterfaces, wanInterfacesPage, wanInterfacesLimit]);

    const paginatedHubSelection = useMemo(() => {
        let pageNumber = hubSelectionPage || 1
        let pageLimit = hubSelectionLimit || DEFAULT_PAGE_SIZE
        const startIndex = (pageNumber - 1) * pageLimit;
        return hubSelection?.slice?.(startIndex, startIndex + pageLimit);
    }, [hubSelection, hubSelectionPage, hubSelectionLimit]);

    const paginatedHubWanSelection = useMemo(() => {
        let pageNumber = hubWanSelectionPage || 1
        let pageLimit = hubWanSelectionLimit || DEFAULT_PAGE_SIZE
        const startIndex = (pageNumber - 1) * pageLimit;
        return hubWanSelection?.slice?.(startIndex, startIndex + pageLimit);
    }, [hubWanSelection, hubWanSelectionPage, hubWanSelectionLimit]);

    const handleAccessNetworksPagination = (e: any, value: number) => {
        setAccessNetworksPage(value);
    }
    const handleAccessNetworksPerPageChange = (e: any) => {
        const value = parseInt(e.target.value);
        setAccessNetworksLimit(value)
    }

    const handleHubGroupsPagination = (e: any, value: number) => {
        setHubGroupsPage(value);
    }
    const handleHubGroupsPerPageChange = (e: any) => {
        const value = parseInt(e.target.value);
        setHubGroupsLimit(value)
    }

    const handleHubPagination = (e: any, value: number) => {
        setHubPage(value)
    }

    const handleHubPerPageChange = (e: any) => {
        const value = parseInt(e.target.value);
        setHubLimit(value)
    }

    const handleVlanPagination = (e: any, value: number) => {
        setVlanPage(value)
    }

    const handleVlanPerPageChange = (e: any) => {
        const value = parseInt(e.target.value);
        setVlanLimit(value)
    }

    const handleRoutePagination = (e: any, value: number) => {
        setRoutePage(value)
    }

    const handleRoutePerPageChange = (e: any) => {
        const value = parseInt(e.target.value);
        setRouteLimit(value)
    }

    const handleServicesPagination = (e: any, value: number) => {
        setServicesPage(value);
    }
    const handleServicesPerPageChange = (e: any) => {
        const value = parseInt(e.target.value);
        setServicesLimit(value)
    }

    const handleWanInterfacesPagination = (e: any, value: number) => {
        setWanInterfacesPage(value);
    }
    const handleWanInterfacesPerPageChange = (e: any) => {
        const value = parseInt(e.target.value);
        setWanInterfacesLimit(value)
    }

    const handleHubSelectionPagination = (e: any, value: number) => {
        setHubSelectionPage(value);
    }
    const handleHubSelectionPerPageChange = (e: any) => {
        const value = parseInt(e.target.value);
        setHubSelectionLimit(value)
    }

    const handleHubWanSelectionPagination = (e: any, value: number) => {
        setHubWanSelectionPage(value);
    }
    const handleHubWanSelectionPerPageChange = (e: any) => {
        const value = parseInt(e.target.value);
        setHubWanSelectionLimit(value)
    }

    const disableButtons = [
        paginatedAccessNetworks,
        paginatedWanInterfaces,
        paginatedVlans,
        paginatedHubGroups,
        paginatedHubs,
        pagionatedServices,
        paginatedRoutes
    ].every(item => !item || item?.length === 0);

    return (
        <Grid className="Form">
            <DialogContent className="deploy-inventory-content register-inventory-content">
                <Grid container className="config-apply-config-target">
                    <Grid lg={12}>
                        <p className="agentNameCss"> {`Agent Name : ${agentName ? agentName : agentId}`}</p>
                    </Grid>
                </Grid>
                <Grid container className="config-apply-config-target" style={{ paddingRight: "10px", marginTop: "10px" }}>
                    <p className="agentNameCss"> ACCESS NETWORKS</p>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box>
                            <Pagination
                                rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                                count={accessNetworks?.length || 0}
                                rowsPerPage={accessNetworksLimit || 0}
                                page={accessNetworksPage || 1}
                                onPageChange={handleAccessNetworksPagination}
                                onRowsPerPageChange={handleAccessNetworksPerPageChange}
                            />
                        </Box>
                        <TableContainer className="agent-table-tableContainer">
                            <Table aria-label="simple table">
                                <TableHead className="tableHead agent-table-tableHead">
                                    <TableRow className="agent-table-tableRow">
                                        <TableCell className="agent-table-tableData font-wt-900">NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">INTERFACE NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">VID</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">INTERFACE IP</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">Routes</TableCell>
                                    </TableRow>
                                </TableHead>
                                {paginatedAccessNetworks?.length > 0 &&
                                    <TableBody >
                                        {
                                            paginatedAccessNetworks?.length > 0 && paginatedAccessNetworks.map((row, index) =>
                                                <TableRow className="agent-table-tabelRow">
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.["name"]}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['interfaceName']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['vid'] ? row['vid'] : '-'}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['interfaceIp'] ? row?.['interfaceIp'] : '-'}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source" colSpan={2}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source innerTable">Network</TableCell>
                                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source innerTable">Gateway</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            {row?.routes?.length > 0 ? <TableBody>
                                                                {row?.routes?.map((route, index) => (
                                                                    <TableRow key={index} className="innerTable-row">
                                                                        <TableCell className="agent-table-tableCell agent-table-tableCell-source">
                                                                            {route?.network}
                                                                        </TableCell>
                                                                        <TableCell className="agent-table-tableCell agent-table-tableCell-source">
                                                                            {route?.gateway}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody> : <TableBody>
                                                                <TableRow className="innerTable-row">
                                                                    <TableCell colSpan={12} className="agent-table-noDataAvailableCss" align="center">No routes available</TableCell>
                                                                </TableRow>
                                                            </TableBody>}
                                                        </Table>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>}
                                {(paginatedAccessNetworks?.length === 0) && <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={12} className="agent-table-noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>}

                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>

                <Grid container className="config-apply-config-target" style={{ paddingRight: "10px", marginTop: "10px" }}>
                    <p className="agentNameCss"> WAN INTERFACES</p>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box>
                            <Pagination
                                rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                                count={wanInterfaces?.length || 0}
                                rowsPerPage={wanInterfacesLimit || 0}
                                page={wanInterfacesPage || 1}
                                onPageChange={handleWanInterfacesPagination}
                                onRowsPerPageChange={handleWanInterfacesPerPageChange}
                            />
                        </Box>
                        <TableContainer className="agent-table-tableContainer">
                            <Table aria-label="simple table">
                                <TableHead className="tableHead agent-table-tableHead">
                                    <TableRow className="agent-table-tableRow">
                                        <TableCell className="agent-table-tableData font-wt-900">NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">INTERFACE NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">INTERFACE IP</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">VID</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">WAN TYPE</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">GATE WAY</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">KeepAlive DROP COUNT</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">KeepAlive INTERVAL</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">KeepAlive TIMEOUT</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">KeepAlive IDLE TIMEOUT</TableCell>
                                    </TableRow>
                                </TableHead>
                                {paginatedWanInterfaces?.length > 0 &&
                                    <TableBody >
                                        {
                                            paginatedWanInterfaces?.length > 0 && paginatedWanInterfaces.map((row, index) =>
                                                <TableRow className="agent-table-tabelRow">
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row["name"]}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['interfaceName']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['interfaceIp']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['vid']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['wanType']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['gateway']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['keepAlive']?.dropCount}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['keepAlive']?.interval}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['keepAlive']?.timeout}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['keepAlive']?.idleTimeout}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>}
                                {(paginatedWanInterfaces?.length === 0) && <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={12} className="agent-table-noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>}

                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
                
                <Grid container className="agent-table-container-edgeEvent" style={{ paddingRight: "10px", marginTop: "10px" }}>
                    <p className="agentNameCss"> BALANCERS</p>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box>
                            <Pagination
                               rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                               count={vlans?.length || 0}
                               rowsPerPage={vlanLimit || 0}
                               page={vlanPage || 1}
                               onPageChange={handleVlanPagination}
                               onRowsPerPageChange={handleVlanPerPageChange}
                            />
                        </Box>
                        <TableContainer className="agent-table-tableContainer">
                            <Table aria-label="simple table">
                                <TableHead className="tableHead agent-table-tableHead">
                                    <TableRow className="agent-table-tableRow">
                                        <TableCell className="agent-table-tableData font-wt-900">BALANCER NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">BALANCER TYPE</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">LEVEL</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">WAN NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">WEIGHT</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">IS SERVER FOLLOWS CLIENT</TableCell>
                                        {/* <TableCell className="agent-table-tableData font-wt-900">MODE</TableCell> */}

                                    </TableRow>
                                </TableHead>
                                {paginatedVlans?.length > 0 &&
                                    <TableBody >
                                        {
                                            paginatedVlans?.length > 0 && paginatedVlans.map((row, index) =>
                                                <TableRow className="agent-table-tabelRow">
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['balancerName']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['balancerType']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['level']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['wanName']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['weight']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['serverFollowsClient'] ? "true" : "false"}</TableCell>
                                                    {/* <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['mode']}</TableCell> */}
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>}
                                {(paginatedVlans?.length === 0) && <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={12} className="agent-table-noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>}

                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>

                <Grid container className="config-apply-config-target" style={{ paddingRight: "10px", marginTop: "10px" }}>
                    <p className="agentNameCss"> HUB GROUPS</p>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box>
                            <Pagination
                                rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                                count={hubGroups?.length || 0}
                                rowsPerPage={hubGroupsLimit || 0}
                                page={hubGroupsPage || 1}
                                onPageChange={handleHubGroupsPagination}
                                onRowsPerPageChange={handleHubGroupsPerPageChange}
                            />
                        </Box>
                        <TableContainer className="agent-table-tableContainer">
                            <Table aria-label="simple table">
                                <TableHead className="tableHead agent-table-tableHead">
                                    <TableRow className="agent-table-tableRow">
                                        <TableCell className="agent-table-tableData font-wt-900"> GROUP NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">HUB NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">PRIORITY</TableCell>
                                    </TableRow>
                                </TableHead>
                                {paginatedHubGroups?.length > 0 &&
                                    <TableBody >
                                        {
                                            paginatedHubGroups?.length > 0 && paginatedHubGroups.map((row, index) =>
                                                <TableRow className="agent-table-tabelRow">
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row["groupName"]}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['hubName']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['priority']}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>}
                                {(paginatedHubGroups?.length === 0) && <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={12} className="agent-table-noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>}

                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>

                <Grid container className="config-apply-config-target" style={{ paddingRight: "10px", marginTop: "10px" }}>
                    <p className="agentNameCss"> HUBS</p>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box>
                            <Pagination
                                rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                                count={hubs?.length || 0}
                                rowsPerPage={hubLimit || 0}
                                page={hubPage || 1}
                                onPageChange={handleHubPagination}
                                onRowsPerPageChange={handleHubPerPageChange}
                            />
                        </Box>
                        <TableContainer className="agent-table-tableContainer">
                            <Table aria-label="simple table">
                                <TableHead className="tableHead agent-table-tableHead">
                                    <TableRow className="agent-table-tableRow">
                                        <TableCell className="agent-table-tableData font-wt-900">NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">Balancer</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">ADDRESS</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">WAN TYPE</TableCell>
                                    </TableRow>
                                </TableHead>
                                {paginatedHubs?.length > 0 &&
                                    <TableBody >
                                        {
                                            paginatedHubs?.length > 0 && paginatedHubs.map((row, index) =>
                                                <TableRow className="agent-table-tabelRow">
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row["name"]}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row["balancer"]}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['address']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['wanType']}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>}
                                {(paginatedHubs?.length === 0) && <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={12} className="agent-table-noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>}

                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>

                <Grid container className="config-apply-config-target" style={{ paddingRight: "10px", marginTop: "10px" }}>
                    <p className="agentNameCss"> HUB SELECTION</p>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box>
                            <Pagination
                                rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                                count={hubSelection?.length || 0}
                                rowsPerPage={hubSelectionLimit || 0}
                                page={hubSelectionPage || 1}
                                onPageChange={handleHubSelectionPagination}
                                onRowsPerPageChange={handleHubSelectionPerPageChange}
                            />
                        </Box>
                        <TableContainer className="agent-table-tableContainer">
                            <Table aria-label="simple table">
                                <TableHead className="tableHead agent-table-tableHead">
                                    <TableRow className="agent-table-tableRow">
                                        <TableCell className="agent-table-tableData font-wt-900">POBE SERVER</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">INTERVAL</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">SELECTION METHOD</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">PRIORITY LIST</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">WINDOW SIZE</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">SMOOTHING FACTOR</TableCell>
                                    </TableRow>
                                </TableHead>
                                {paginatedHubSelection?.length > 0 &&
                                    <TableBody >
                                        {
                                            paginatedHubSelection?.length > 0 && paginatedHubSelection.map((row, index) =>
                                                <TableRow className="agent-table-tabelRow">
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.["probeServer"]}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.["interval"]}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['selectionMethod']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['priorityList']?.map(item => item)?.join(', ')}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['windowSize']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['smoothingFactor']}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>}
                                {(paginatedHubSelection?.length === 0) && <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={6} className="agent-table-noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>}

                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>

                <Grid container className="config-apply-config-target" style={{ paddingRight: "10px", marginTop: "10px" }}>
                    <p className="agentNameCss"> HUB WAN SELECTION</p>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box>
                            <Pagination
                                rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                                count={hubWanSelection?.length || 0}
                                rowsPerPage={hubWanSelectionLimit || 0}
                                page={hubWanSelectionPage || 1}
                                onPageChange={handleHubWanSelectionPagination}
                                onRowsPerPageChange={handleHubWanSelectionPerPageChange}
                            />
                        </Box>
                        <TableContainer className="agent-table-tableContainer">
                            <Table aria-label="simple table">
                                <TableHead className="tableHead agent-table-tableHead">
                                    <TableRow className="agent-table-tableRow">
                                        <TableCell className="agent-table-tableData font-wt-900">WAN TYPE</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">PHASE</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">RTT DIFFERENCE THRESHOULD</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">PROBES</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">TIMEOUT</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">INTERVAL</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">TIME DELTA</TableCell>
                                    </TableRow>
                                </TableHead>
                                {paginatedHubWanSelection?.length > 0 &&
                                    <TableBody >
                                        {
                                            paginatedHubWanSelection?.length > 0 && paginatedHubWanSelection.map((row, index) =>
                                                <TableRow className="agent-table-tabelRow">
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.["wanType"]}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.["phase"]}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['rttDiffThreshold']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['probes']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['timeout']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['interval']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['timeDelta']}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>}
                                {(paginatedHubWanSelection?.length === 0) && <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={6} className="agent-table-noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>}

                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
                
                <Grid container className="config-apply-config-target" style={{ paddingRight: "10px", marginTop: "10px" }}>
                    <p className="agentNameCss"> SERVICES</p>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box>
                            <Pagination
                                rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                                count={services?.length || 0}
                                rowsPerPage={servicesLimit || 0}
                                page={servicesPage || 1}
                                onPageChange={handleServicesPagination}
                                onRowsPerPageChange={handleServicesPerPageChange}
                            />
                        </Box>
                        <TableContainer className="agent-table-tableContainer">
                            <Table aria-label="simple table">
                                <TableHead className="tableHead agent-table-tableHead">
                                    <TableRow className="agent-table-tableRow">
                                        <TableCell className="agent-table-tableData font-wt-900">NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">HUB GROUP</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">SELECTION METHOD</TableCell>
                                    </TableRow>
                                </TableHead>
                                {pagionatedServices?.length > 0 &&
                                    <TableBody >
                                        {
                                            pagionatedServices?.length > 0 && pagionatedServices.map((row, index) =>
                                                <TableRow className="agent-table-tabelRow">
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row["name"]}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['hubGroup']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['selectionMethod']}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>}
                                {(pagionatedServices?.length === 0) && <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={12} className="agent-table-noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>}

                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
                
                <Grid container className="agent-table-container-edgeEvent" style={{ paddingRight: "10px", marginTop: "10px" }}>
                    <p className="agentNameCss"> ROUTES</p>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box>
                            <Pagination
                                rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                                count={routes?.length || 0}
                                rowsPerPage={routeLimit || 0}
                                page={routePage || 1}
                                onPageChange={handleRoutePagination}
                                onRowsPerPageChange={handleRoutePerPageChange}
                            />
                        </Box>
                        <TableContainer className="agent-table-tableContainer">
                            <Table aria-label="simple table">
                                <TableHead className="tableHead agent-table-tableHead">
                                    <TableRow className="agent-table-tableRow">
                                        <TableCell className="agent-table-tableData font-wt-900">NAME</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">VID / Access Network</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">SOURCE NETWORK</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">DESTINATION NETWORK</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">SERVICE</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">BALANCER</TableCell>
                                        <TableCell className="agent-table-tableData font-wt-900">QOS</TableCell>
                                    </TableRow>
                                </TableHead>
                                {paginatedRoutes?.length > 0 &&
                                    <TableBody >
                                        {
                                            paginatedRoutes?.length > 0 && paginatedRoutes.map((row, index) =>
                                                <TableRow className="agent-table-tabelRow">
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['name']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row?.['vid'] ? row?.['vid'] : row?.['accessNetworkName'] ? row?.['accessNetworkName'] : '-'}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['sourceNet']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['destNet']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['service']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['balancer']}</TableCell>
                                                    <TableCell className="agent-table-tableCell agent-table-tableCell-source">{row['qos']}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>}
                                {(paginatedRoutes?.length === 0) && <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={12} className="agent-table-noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>}

                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>

                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "30px", marginRight: "10px", gap: "16px" }}>
                    <Button className="confirm-dialogue-cancel" style={{ color: "#264c86" }} onClick={() => { handleClose() }}> Cancel </Button>
                    {!isEditActionPopup && <Button variant="contained" style={{ background: disableButtons ? 'rgb(232, 240, 253)' : '#264c86', color: disableButtons ? 'rgb(38, 76, 134)' : '#fff' }} onClick={() => { handleSave() }} disabled={disableButtons}> Save </Button>}
                    {isEditActionPopup && <Button variant="contained" style={{ background: !uploadedFile ? 'rgb(232, 240, 253)' : '#264c86', color: !uploadedFile ? 'rgb(38, 76, 134)' : '#fff' }} onClick={() => { handleSave() }} disabled={!uploadedFile}> Apply on Start </Button>}
                    {isEditActionPopup && <Button variant="contained" style={{ background: !uploadedFile ? 'rgb(232, 240, 253)' : '#264c86', color: !uploadedFile ? 'rgb(38, 76, 134)' : '#fff' }} onClick={() => { handleApplyNow() }} disabled={!uploadedFile}> Apply Now </Button>}
                </div>
            </DialogContent>
        </Grid>
    )
}


const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
});

export default withRouter(
    connect(mapStateToProps, {
        upgradeDevicetoLatestEOSversion, backupConfigNow, applyGoldenConfig, rebootDevice, backupConfigData, getLicenseTypes, upgradeInventoryLicense, uploadAgentConfig
    })(AgentConfigSummary)
);